export default __webpack_public_path__ + "static/media/WM0410.34I-43493_-25993_0.855a641b.jpg";